import { Link, Stack, Typography } from '@mui/material'
import { websiteHref } from '../../utils/common'
import { linkStyle } from '../ProjectPage/ProjectInfo/style'

type ProjectExternalLinksModalBodyProps = {
  links: string[]
}

export const ProjectExternalLinksModalBody = ({ links }: ProjectExternalLinksModalBodyProps) => {
  if (links.length === 0) {
    return <Typography>Ссылки не указаны.</Typography>
  }

  return (
    <Stack gap={1.5}>
      {links.map((link) => (
        <Link
          key={link}
          component="a"
          href={websiteHref(link)}
          target="_blank"
          rel="noopener noreferrer"
          variant="black-14-light"
          title={link}
          sx={{ ...linkStyle, wordBreak: 'break-all' }}
        >
          {link}
        </Link>
      ))}
    </Stack>
  )
}
